import { UserLayout, BasicLayout, RouteView } from '@/layouts'

// 平台路由
const asyncRouterMap = [
  {
    path: '/manage',
    name: 'manage',
    component: BasicLayout,
    redirect: '/manage/dashboard',
    children: [
      // 数据
      {
        path: '/manage/dashboard',
        name: 'manage-dashboard',
        redirect: '/manage/dashboard/analysis',
        component: RouteView,
        meta: {
          title: '数据',
          keepAlive: true,
          icon: 'icon-yingxiao',
          permission: [
            'manage-dashboard-analysis'
          ]
        },
        children: [
          {
            path: '/manage/dashboard/analysis',
            name: 'manage-dashboard-analysis',
            component: () => import('@/views/hg-public/dashboard/Analysis'),
            meta: { title: '数据统计', keepAlive: true, permission: ['manage-dashboard-analysis'] }
          }
        ]
      },

      // 文章
      {
        path: '/manage/news',
        name: 'manage-news',
        redirect: '/manage/news/list',
        component: RouteView,
        meta: { title: '文章', keepAlive: true, icon: 'icon-shenqingjilu', permission: ['manage-news-list', 'manage-news-type'] },
        children: [

          {
            path: '/manage/news/list',
            name: 'manage-news-list',
            component: () => import('@/views/hg-public/news/List'),
            meta: { title: '新闻管理', keepAlive: true, permission: ['manage-news-list'] }
          },
          {
            path: '/manage/news/type',
            name: 'manage-news-type',
            component: () => import('@/views/hg-public/news/NewsType'),
            meta: { title: '新闻分类', keepAlive: true, permission: ['manage-news-type'] }
          }
        ]
      },

      // 广告
      {
        path: '/manage/ad',
        name: 'manage-ad',
        redirect: '/manage/ad/list',
        component: RouteView,
        meta: { title: '广告', keepAlive: true, icon: 'icon-duilianguanggao', permission: ['manage-ad-list'] },
        children: [
          {
            path: '/manage/ad/list',
            name: 'manage-ad-list',
            component: () => import('@/views/hg-public/ad/List'),
            meta: { title: '广告管理', keepAlive: true, permission: ['manage-ad-list'] }
          }
        ]
      },

      // 服务
      {
        path: '/manage/goods',
        name: 'manage-goods',
        redirect: '/manage/goods/list',
        component: RouteView,
        meta: { title: '服务', keepAlive: true, icon: 'icon-brand', permission: ['manage-goods-list', 'manage-goods-types'] },
        children: [
          {
            path: '/manage/goods/list',
            name: 'manage-goods-list',
            component: () => import('@/views/hg-platform/goods/List'),
            meta: { title: '服务管理', keepAlive: true, permission: ['manage-goods-list'] }
          },
          {
            path: '/manage/goods/types',
            name: 'manage-goods-types',
            component: () => import('@/views/hg-platform/goods/Types'),
            meta: { title: '服务分类', keepAlive: true, permission: ['manage-goods-types'] }
          }
        ]
      },

      // 订单
      {
        path: '/manage/order',
        name: 'manage-order',
        redirect: '/manage/order/list',
        component: RouteView,
        meta: { title: '订单', keepAlive: true, icon: 'icon-dingdan', permission: ['manage-order-list'] },
        children: [
          {
            path: '/manage/order/list',
            name: 'manage-order-list',
            component: () => import('@/views/hg-platform/order/List'),
            meta: { title: '订单管理', keepAlive: true, permission: ['manage-order-list'] }
          }
        ]
      },

      // 用户
      {
        path: '/manage/user',
        name: 'manage-user',
        redirect: '/manage/admin/list',
        component: RouteView,
        meta: {
          title: '用户',
          keepAlive: true,
          icon: 'icon-yonghu1',
          permission: [
            'manage-admin-list2',
            'manage-admin-list3',
            'manage-admin-list4',
            'manage-admin-customer',
            'manage-admin-list',
            'manage-admin-enter'
          ]
        },
        children: [
          {
            path: '/manage/admin/list',
            name: 'manage-admin-list',
            component: () => import('@/views/hg-public/user/List'),
            meta: { title: '平台管理员', keepAlive: true, permission: ['manage-admin-list'] }
          },
          {
            path: '/manage/admin/list2',
            name: 'manage-admin-list2',
            component: () => import('@/views/hg-public/user/List2'),
            meta: { title: '区域管理员', keepAlive: true, permission: ['manage-admin-list2'] }
          },
          {
            path: '/manage/admin/list3',
            name: 'manage-admin-list3',
            component: () => import('@/views/hg-public/user/List3'),
            meta: { title: '客服', keepAlive: true, permission: ['manage-admin-list3'] }
          },
          {
            path: '/manage/admin/list4',
            name: 'manage-admin-list4',
            component: () => import('@/views/hg-public/user/List4'),
            meta: { title: '维修工', keepAlive: true, permission: ['manage-admin-list4'] }
          },
          {
            path: '/manage/admin/customer',
            name: 'manage-admin-customer',
            component: () => import('@/views/hg-public/user/Customer'),
            meta: { title: '客户', keepAlive: true, permission: ['manage-admin-customer'] }
          },
          {
            path: '/manage/admin/enter',
            name: 'manage-admin-enter',
            component: () => import('@/views/hg-public/user/Enter'),
            meta: { title: '入驻申请', keepAlive: true, permission: ['manage-admin-enter'] }
          }
        ]
      },

      // 权限
      {
        path: '/manage/auth',
        name: 'manage-auth',
        redirect: '/manage/auth/roles',
        component: RouteView,
        meta: { title: '权限', keepAlive: true, icon: 'icon-quanxian', permission: ['manage-auth-roles', 'manage-auth-rules'] },
        children: [
          {
            path: '/manage/auth/roles',
            name: 'manage-auth-roles',
            component: () => import('@/views/hg-public/auth/Roles'),
            meta: { title: '角色列表', keepAlive: true, permission: ['manage-auth-roles'] }
          },
          {
            path: '/manage/auth/rules',
            name: 'manage-auth-rules',
            component: () => import('@/views/hg-public/auth/Rules'),
            meta: { title: '权限列表', keepAlive: true, permission: ['manage-auth-rules'] }
          }
        ]
      },

      {
        path: '/manage/config',
        name: 'manage-config',
        redirect: '/manage/config/index',
        component: RouteView,
        meta: { title: '系统', keepAlive: true, icon: 'icon-icon02', permission: ['manage-config-index', 'manage-config-department', 'manage-config-logs'] },
        children: [
          {
            path: '/manage/config/index',
            name: 'manage-config-index',
            component: () => import('@/views/hg-public/config/Index'),
            meta: { title: '系统配置', keepAlive: true, permission: ['manage-config-index'] }
          },
          {
            path: '/manage/config/department',
            name: 'manage-config-department',
            component: () => import('@/views/hg-public/config/Department'),
            meta: { title: '区域配置', keepAlive: true, permission: ['manage-config-department'] }
          },
          {
            path: '/manage/config/logs',
            name: 'manage-config-logs',
            component: () => import('@/views/hg-platform/log/List'),
            meta: { title: '操作日志', keepAlive: true, permission: ['manage-config-logs'] }
          }
        ]
      }
    ]
  }
]

const manage = [
  {
    path: '/',
    name: 'index',
    redirect: '/manage',
    component: RouteView
  },
  {
    path: '/manage',
    name: 'manage',
    component: BasicLayout
  },
  {
    path: '/manage',
    component: UserLayout,
    redirect: '/manage/login',
    children: [
      {
        path: '/manage/login',
        name: 'manage-login',
        component: () => import('@/views/hg-public/manage/Login'),
        meta: { title: '平台管理登录' }
      },
      {
        path: '/manage/regist',
        name: 'manage-regist',
        component: () => import('@/views/hg-public/manage/Regist'),
        meta: { title: '注册' }
      }
    ]
  }
]

var constantRouterMap = [
  {
    path: '/account',
    name: 'account',
    component: BasicLayout,
    redirect: '/account/index',
    children: [
      {
        path: '/account/index',
        name: 'account-index',
        redirect: '/account/info',
        component: () => import('@/views/hg-public/account/Index'),
        meta: { title: '账号管理', keepAlive: true },
        children: [
          {
            path: '/account/info',
            name: 'account-info',
            component: () => import('@/views/hg-public/account/Info'),
            meta: { title: '我的信息', keepAlive: true }
          }
        ]
      }
    ]
  }
]

const notfound = [
  {
    path: '/404',
    name: '404',
    component: () => import(/* webpackChunkName: "fail" */ '@/views/hg-public/exception/404')
  },
  {
    path: '/:pathMatch(.*)*',
    component: () => import(/* webpackChunkName: "fail" */ '@/views/hg-public/exception/404')
  }
]

constantRouterMap.push(...manage)
constantRouterMap.push(...notfound)

const hasHiddenChildren = ['warehouse-plan-index', 'chef-plan-index', 'chef-dish-index', 'chef-combo-index', 'chef-order-index', 'hotel-dish-index', 'hotel-combo-index']

export {
  constantRouterMap,
  asyncRouterMap,
  hasHiddenChildren,
  notfound
}
